module.exports = __webpack_public_path__ + "fonts/Roboto-Light.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Roboto-Light.eot
// module id = 263
// module chunks = 0